import {SET_NAV_REVIEWS_PARAMS, SET_REVIEWS_LIST} from "./constans";

let initialState = {

};

const reviewsReducers = (state = initialState, action) => {

    switch (action.type) {
        case SET_REVIEWS_LIST:
            return {
                ...state,
                reviews: action.payload
            }

        case SET_NAV_REVIEWS_PARAMS:
            return {
                ...state,
                navParams: action.payload
            }

        default:
            return state;
    }
};


export default reviewsReducers;